
import { Crown, Shield, Star, User } from "lucide-react";

export const getRoleIcon = (role: string | null) => {
  const roleType = role?.toLowerCase() || '';
  if (roleType.includes('director')) return <Crown className="h-4 w-4 text-purple-400" />;
  if (roleType.includes('manager')) return <Shield className="h-4 w-4 text-blue-400" />;
  if (roleType.includes('lead')) return <Star className="h-4 w-4 text-green-400" />;
  return <User className="h-4 w-4 text-orange-400" />;
};

export const getRoleColor = (role: string | null) => {
  const roleType = role?.toLowerCase() || '';
  if (roleType.includes('director')) return 'bg-purple-500/20 text-purple-300 border-purple-500/30';
  if (roleType.includes('manager')) return 'bg-blue-500/20 text-blue-300 border-blue-500/30';
  if (roleType.includes('lead')) return 'bg-green-500/20 text-green-300 border-green-500/30';
  return 'bg-orange-500/20 text-orange-300 border-orange-500/30';
};

export const getRoleTypeColor = (roleType: string | null) => {
  if (!roleType) return 'bg-gray-500/20 text-gray-300 border-gray-500/30';
  
  switch (roleType) {
    case 'project-director':
      return 'bg-purple-500/20 text-purple-300 border-purple-500/30';
    case 'project-manager':
      return 'bg-blue-500/20 text-blue-300 border-blue-500/30';
    case 'team-lead':
      return 'bg-green-500/20 text-green-300 border-green-500/30';
    case 'team-member':
      return 'bg-orange-500/20 text-orange-300 border-orange-500/30';
    default:
      return 'bg-gray-500/20 text-gray-300 border-gray-500/30';
  }
};
